import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface TimelineSectionProps {
  items: Article[];
}

export default function TimelineSection({ items }: TimelineSectionProps) {
  return (
    <section aria-labelledby="timeline-heading" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 id="timeline-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              往期存档时间线
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按照发布时间从新到旧排列，最近整理的往期热料都在这里。
            </p>
          </div>
          <Link
            to="/archive"
            className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            进入完整存档 →
          </Link>
        </div>

        <ol className="relative mt-8 border-l border-background-300 pl-5 md:pl-7">
          {items.map((item) => (
            <li key={item.id} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[27px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 md:-left-[35px]" />
              <div className="flex flex-col gap-1 md:flex-row md:items-baseline md:gap-4">
                <time
                  dateTime={item.date}
                  className="w-24 shrink-0 font-heading text-sm font-semibold text-primary-600"
                >
                  {item.date}
                </time>
                <div className="flex-1">
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    <Link to={`/article/${item.id}`} className="transition-colors hover:text-primary-600">
                      {item.title}
                    </Link>
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="mt-2 flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-800">
                      {item.category}
                    </span>
                    {item.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="rounded-full bg-background-200 px-2.5 py-0.5 text-foreground-600">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}